<template>
  <div class="wrap">
    <div class="head clearfix yp-topbar">
      <ul>
        <li class="btn fl" @click="choose()" v-show="isA">
          {{isChooseAll ? '取消全选' : '全选'}}
        </li>
        <li class="btn fr" @click="cancel" v-show="isA">取消</li>
        <li class="tittle" v-show="!len">我的收藏</li>
        <li class="tittle" v-show="len">已选择{{len}}文件</li>
        <li @click="checkMobile" id="check-collect" class="check-mobile" v-show="!isA"></li>
        <router-link to="/more/setinfo" slot="left" v-show="!isA">
          <li class="back"></li>
        </router-link>
      </ul>
    </div>
    <div class="jpg" v-if="list.length===0" v-cloak>
      <div>
        <img src="../../assets/images/null.png" alt="">
        <p>您还没有收藏文件夹～</p>
      </div>
    </div>
    <ul class="ulbox" v-else ref="ulBox"
        infinite-scroll-distance="0" infinite-scroll-immediate-check="false"
        v-infinite-scroll="loadMore" infinite-scroll-disabled="moreLoading">
      <li v-for="(item,index) in list">
        <div class="liList">
          <div class="left">
            <em class="check" v-show="isA" @click="checked(item)" ref="mycheck"
                v-bind:class="{'checked': item.isB, 'nochecked': !item.isB}"
                :fileId="item.id"></em>
            <!--<i v-bind:class="[sliceType(item.fileName, item.isDir)]"></i>-->
            <span :class="styleObject(item.fileName,item.isDir,item.fileCategory)"
                  v-if="sliceType(item.fileName,item.isDir,item.fileCategory)!=='package'">
               <i :class="classObject(item.fileName,item.isDir,item.fileCategory)" class="iconfont"></i>
          </span>
            <svg class="icon" aria-hidden="true" v-else>
              <use xlink:href="#icon-package"></use>
            </svg>
          </div>
          <div class="con">
            <div class="contentIn" @click="deepPath(item.id,item.fileName,item.isDir,item.fileCategory)">
              <h3 class="filename">{{item.fileName}}</h3>
              <span class="filetime">{{item.gmtModified}}</span>
            </div>
          </div>
        </div>
        <div id="more" @click="toggleUp(index)" :class="{'more':up===index}"></div>
        <div class="div" v-if="select===index">
          <ul class="listBox clearfix">
            <li>
              <!--<img src="../../assets/images/share_gray.png" alt="">-->
              <i class="iconfont icon-fenxiang" style="font-size: .48rem;
    display: block;color: #999999"></i>
              <p @click="currency(item.id,'分享')" :id="item.id" ref="share">分享</p>
            </li>
            <li v-if="false">
              <!--<img src="../../assets/images/upload_gray.png" alt="">-->
              <i class="iconfont icon-xiazai" style="font-size: .48rem;
    display: block;color: #999999"></i>
              <p @click="download('1',item.id,item.isDir,'',item.fileName)" :id="item.id" ref="download">下载</p>
            </li>
            <li>
              <!--<img src="../../assets/images/nocollect_gray.png" alt="">-->
              <i class="iconfont icon-quxiaoshoucang" style="font-size: .48rem;
    display: block;color: #999999"></i>
              <p @click="noCollect" :id="item.id" ref="nocollect">取消收藏</p>
            </li>
          </ul>
        </div>
      </li>
    </ul>
    <mt-tabbar v-show="isA" v-bind:class="{'selected': isA, 'selected-t': opacity}">
      <mt-tab-item id="分享">
        <!--<img slot="icon" src="../../assets/images/share-t.png" @click="delActions('分享')">-->
        <i class="iconfont icon-fenxiang" @click="delActions('分享')" style="font-size: .48rem;
    display: block;margin: 0 auto;"></i>
        <span @click="delActions('分享')">分享</span>
      </mt-tab-item>
      <mt-tab-item id="下载" v-if="false">
        <!--<img slot="icon" src="../../assets/images/loader-t.png" @click="downloads('下载')">-->
        <i class="iconfont icon-xiazai" @click="downloads('下载')" style="font-size: .48rem;
    display: block;margin: 0 auto;"></i>
        <span @click="downloads('下载')">下载</span>
      </mt-tab-item>
      <mt-tab-item id="取消收藏">
        <!--<img slot="icon" src="../../assets/images/nocollect_t.png"-->
        <!--@click="noCollects('取消收藏')">-->
        <i class="iconfont icon-quxiaoshoucang" @click="noCollects('取消收藏')" style="font-size: .48rem;
    display: block;margin: 0 auto;"></i>
        <span @click="noCollects('取消收藏')">取消收藏</span>
      </mt-tab-item>
    </mt-tabbar>
    <share :fileId="fileId" v-if="currentValue" v-on:share="listenToShare"></share>
    <div class="v-model" style="z-index: 2000;height: 100%;" v-if="currentValue"
         @click="currentValue=false;time=false"></div>
  </div>
</template>
<script type="text/ecmascript-6">
  import apis from '../../apis/index'
  import cloudApi from '../../apis/cloudStorageApi'
  import { formaTime } from '../../assets/js/tools'
  import { MessageBox, Toast } from 'mint-ui'
  import Clipboard from 'clipboard'
  import { downLoadFile } from '../../components/download.js'
  import share from '../../components/share'
  // import downList from '../../components/strore.js'

  export default {
    data () {
      return {
        isShow: false,
        opacity: true,
        // 隐藏与显示
        isA: false,
        isB: false,
        len: 0,
        fileId: '',
        up: '',
        time: 0,
        ids: [],
        delfileids: [],
        currentValue: false,
        isChooseAll: false,
        shareVisible: false,
        clipFlag: true,
        pid: 'rootpath',
        totalPages: '',
        page: 0,
        size: 20,
        parentId: [],
        info: {
          page: 0,
          size: 20
        },
        list: [],
        select: '',
        flag: false,
        id: 'id'
      }
    },
    components: {
      formaTime,
      MessageBox,
      Toast,
      downLoadFile,
      share
    },
    mounted () {
      this.load()
    },
    methods: {
      listenToShare (data) {
        this.currentValue = data
      },
      classObject (val, val2, val3) {
        let type = this.sliceType(val, val2, val3)
        return 'icon-' + type
      },
      styleObject (val, val2, val3) {
        let type = this.sliceType(val, val2, val3)
        if (type === 'excel') {
          return 'excel'
        } else if (type === 'pdf') {
          return 'pdf'
        } else if (type === 'word') {
          return 'word'
        } else if (type === 'txt') {
          return 'txt'
        } else if (type === 'pic') {
          return 'pic'
        } else if (type === 'muisc') {
          return 'muisc'
        } else if (type === 'dir') {
          return 'dir'
        } else if (type === 'html') {
          return 'html'
        } else if (type === 'shareDir') {
          return 'shareDir1'
        } else {
          return 'weizhi'
        }
      },
      toggleUp (index) {
        if (this.select === index) {
          this.select = ''
          this.up = ''
        } else {
          this.select = index
          this.up = index
        }
      },
      checkMobile () {
        this.flag ? this.flag = false : this.flag = true
        this.isA ? this.isA = false : this.isA = true
        this.select = ''
      },
      choose () {
        if (this.isChooseAll) {
          this.cancelChooseAll()
        } else {
          this.checkAll()
        }
      },
      checkAll () {
        this.isChooseAll = true
        this.len = this.list.length
        if (this.list.length > 0) {
          this.list.forEach((row) => {
            row.isB = true
          })
        }
        this.opacity = false
      },
      cancelChooseAll () {
        this.isChooseAll = false
        this.len = 0
        if (this.list.length > 0) {
          this.list.forEach((row) => {
            row.isB = false
          })
        }
        this.opacity = true
      },
      checked (item) {
        if (item.isB === undefined) {
          this.$set(item, 'isB', true)
          this.len++
          this.opacity = false
          return
        }
        if (item.isB) {
          item.isB = false
          this.len--
          if (this.len === 0) {
            this.opacity = true
          } else {
            this.opacity = false
          }
        } else {
          item.isB = true
          this.opacity = false
          this.len++
        }
      },
      cancel () {
        this.index = this.indexs
        this.isB = false
        this.opacity = true
        this.isA ? this.isA = false : this.isA = true
        this.isChooseAll = false
        this.cancelChooseAll()
      },
      noCollect () {
        var _this = this
        var id = this.$refs.nocollect[0].id
        MessageBox.confirm('取消收藏', '', {
          message: '<div class="title">取消收藏</div><div class="info">确定要取消收藏吗？</div>',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(function () {
          apis.request(cloudApi.removeFavorite, {fileIds: id}).then(function () {
            _this.load()
            Toast({
              message: '取消收藏',
              iconClass: 'icon-success'
            })
            _this.restore()
          }).catch(function (error) {
            Toast({
              message: error.response.data.message,
              iconClass: 'icon-error'
            })
          })
        })
      },
      currency (itemId, type) {
        this.fileId = itemId
        if (type === '分享') {
          this.currentValue = true
          this.time = 0
        }
      },
      shareBegin () {
        var _this = this
        apis.request(cloudApi.share, {
          fileIds: _this.fileId,
          shareType: 0,
          validTime: _this.time
        }).then(function (response) {
          Toast({
            message: '分享成功',
            iconClass: 'icon-success'
          })
          _this.clipFlag = false
          let shareLink = response.data.shareLink
          /* eslint-disable */
          if (_this.clipFlag === false) {
            new Clipboard('#clipboard', {
              text: function () {
                return shareLink
              }
            })
          }
        }).catch(function (error) {
          Toast({
            message: error.response.data.message,
            iconClass: 'icon-error'
          })
        })
      },
      clip () {
        if (this.clipFlag === false) {
          this.restore()
          this.cancelChooseAll()
          Toast({
            message: '链接已复制',
            iconClass: 'icon-success'
          })
        }
      },
      noCollects () {
        if(this.list.length>0) {
          this.list.forEach((item) => {
           if(item.isB) {
             this.ids.push(item.id)
             this.box()
           }
          })
        }
      },
      delActions () {
        this.list.forEach((item) => {
          if (item.isB) {
            this.currentValue = true
            this.ids.push(item.id)
          }
        })
        this.fileId = this.ids
      },
      box () {
        MessageBox.confirm('取消收藏', {
          message: '<div class="title">取消收藏</div><div class="info">确定要取消收藏吗？</div>',
          confirmButtonText: '确定',
          cancelButtonText: '取消'
        }).then(() => {
          apis.request(cloudApi.removeFavorite, {fileIds: this.ids.join(',')}).then(() => {
            this.load()
            Toast({
              message: '取消收藏',
              iconClass: 'icon-success'
            })
            this.restore()
          }).catch((error)=> {
            Toast({
              message: error.response.data.message,
              iconClass: 'icon-error'
            })
          })
        })
      },
      load () {
        var _this = this
        apis.request(cloudApi.favorite, _this.info).then(function (response) {
          var data = response.data.content
          _this.list = []
          if (data.length > 0) {
            for (var i = 0; i < data.length; i++) {
              data[i].gmtModified = formaTime(data[i].gmtModified)
              _this.id = data[i].id
              _this.list.push(data[i])
            }
            _this.totalPages = response.data.totalPages
          } else {
            _this.list = []
          }
          return false
        }).catch(function (error) {
        })
      },
      // 点击进入下一级目录
      loadMore () {
        this.loading = true
        setTimeout(() => {
          let _this = this
          _this.page++
//          if (_this.page < _this.totalPages) {
//          }
          apis.request(cloudApi.favorite, {page: _this.page, size: _this.size}).then(function (res) {
            let list0 = []
            let data = res.data.content
            if (data.length > 0) {
              for (var i = 0; i < data.length; i++) {
                list0.push(data[i])
                data[i].gmtCreate = formaTime(data[i].gmtCreate)
              }
              if (_this.list && list0) {
                _this.list = _this.list.concat(list0)
              }
            }
          })
          this.loading = false
        }, 250)
      },
      deepPath (index, fileName, isDir, fileCategory) {
        var _this = this
        // 判断是否是一个文件夹
        if (isDir === 1) {
          apis.request(cloudApi.fileCatalog, {fileId: index}).then(function (response) {
            var data = response.data
            if (data.length > 0) {
              if (fileCategory === 1) {
                _this.list = [{pid: 'rootpath', index: '个人文件'}]
                for (var i = 0; i < data.length; i++) {
                  _this.list.push({pid: data[i].id, index: data[i].fileName})
                }
                _this.list.push(fileName)
                _this.$router.push({name: 'index', params: _this.list})
                _this.index = fileName
              } else if (fileCategory === 2) {
                _this.list = [{pid: '', index: '共享文件'}]
                for (var i = 0; i < data.length; i++) {
                  _this.list.push({pid: data[i].id, index: data[i].fileName})
                }
                _this.list.push(fileName)
                _this.$router.push({name: 'ShareFile', params: _this.list})
              }
            }
          }).catch(function (error) {
          })
        }
      },
      sliceType: function (val, num, flag) {
//        if (num === 1 && flag !== undefined) {
//          return 'shareDir'
//        }
        if (val !== '' || undefined) {
          var point = val.lastIndexOf('.')
          var type = val.substring(point + 1).toLowerCase()
          if (num === 1) {
            if (flag === 2) {
              return 'shareDir'
            } else {
              return 'dir'
            }
          }
          if (type === 'jpg' || type === 'gif' || type === 'JPG' || type === 'GIF' || type === 'png') {
            return 'pic'
          } else if (type === 'avi' || type === 'rmvb' || type === 'rm' || type === 'asf' || type === 'divx' || type === 'mpg' || type === 'mpeg' || type === 'mpe' || type === 'mp4' || type === 'mkv' || type === 'vob ') {
            return 'video'
          } else if (type === 'WAVE' || type === 'AIFF' || type === 'MPEG' || type === 'MP3' || type === 'MIDI' || type === 'mp3') {
            return 'muisc'
          } else if (num === 1) {
            return 'dir'
          } else if (type === 'txt') {
            return 'txt'
          } else if (type === 'pdf') {
            return 'pdf'
          } else if (type === 'doc' || type === 'docx') {
            return 'word'
          } else if (type === 'ppt' || type === 'pptx') {
            return 'ppt'
          } else if (type === 'xls' || type === 'xlsx') {
            return 'excel'
          } else if (type === 'html' || type === 'htm') {
            return 'html'
          } else if (type === 'wps' || type === 'wpt') {
            return 'wps'
          } else if (type === 'zip' || type === 'rar') {
            return 'package'
          } else {
            return 'default'
          }
        }
      },
      restore () {
        this.opacity = true
        this.select = ''
        this.isA = false
        this.isB = false
        this.fileId = ''
        this.index = this.indexs
        this.flag = false
        this.time = 0
        this.len = 0
        this.up = ''
        this.isChooseAll = false
        this.currentValue = false
        this.shareVisible = false
        this.clipFlag = true
        this.page = 0
        this.size = 20
        this.info = {
          page: 0,
          size: 20
        }
      },
      // 单个下载
      download () {
        Toast('文件正在下载...')
        // downList.push(...arguments)
        downLoadFile(...arguments)
      },
      // 多文件下载
      downloads () {
        if(this.list.length>0) {
          this.list.forEach((row) => {
            if(row.isB) {
             this.ids.push(row.id)
              this.download('1', this.ids.join(','), '0')
              this.restore()
            }
          })
        }
      }
    }
  }
</script>
<style scoped lang="scss">
  .shareDir1 {
    color: #47A3FB;
  }

  [v-cloak] {
    display: none;
  }

  .iconfont {
    font-size: 0.62rem;
  }

  .wrap {
    padding-top: 1.28rem;
    height: 100%;
  }

  .head {
    position: fixed;
    top: 0;
    height: 1.28rem;
    width: 100%;
    padding-top: 0.32rem;
    z-index: 1;
  }

  .head .tittle {
    position: absolute;
    color: #fff;
    left: 40%;
    font-size: .36rem;
    margin-top: .2rem;
  }

  .head ul {
    text-align: center;
    /*position: relative;*/
    overflow: hidden;
    padding: 0 .3rem;
  }

  .check-mobile {
    background: url("../../assets/images/check-mobile.png") center no-repeat;
    background-size: 0.36rem 0.36rem;
  }

  #check-collect {
    width: 0.36rem;
    height: 0.36rem;
    float: right;
    margin-top: .23rem;
  }

  /*无内容时的样子*/
  .jpg {
    /*position: relative;*/
    height: 100%;
  }

  .jpg > div {
    position: absolute;
    left: 50%;
    top: 50%;
    transform: translate(-50%, -50%);
    text-align: center;
  }

  .jpg div p {
    font-size: 0.28rem;
    color: #41464c;
  }

  .ulbox {
    background-color: #fff;
    overflow-y: scroll;
    height: 100%;
  }

  .ulbox > li {
    position: relative;
    border-bottom: 1px solid #e5e5e5;
    text-align: left;
  }

  .div {
    height: .98rem;
    background: #f7f7fa;
  }

  .listBox {
    overflow: hidden;
    padding: .1rem 0;
  }

  .listBox > li {
    display: inline-block;
    width: 50%;
    text-align: center;
    float: left;
  }

  .listBox > li img {
    width: 0.34rem;
    height: 0.36rem;
    margin: 0 auto;
  }

  .left {
    padding-left: .2rem;
    display: inline-block;
  }

  .con {
    display: inline-block;
  }

  .contentIn {
    margin-left: .2rem;
    h3 {
      width: 3rem;
      /*height: 0.4rem;*/
      /*overflow: hidden;*/
      /*text-overflow: ellipsis;*/
      /*white-space: nowrap;*/
      word-break: break-all;
      font-size: 0.28rem;
      color: #1d1f22;
    }
    .filetime {
      font-size: 0.2rem;
      color: #9b9b9b;
      vertical-align: middle;
    }
  }

  #more {
    width: 0.2rem;
    height: 0.26rem;
    position: absolute;
    right: 0.3rem;
    top: 0.4rem;
    background: url("../../assets/images/down.png") center no-repeat;
    background-size: 0.18rem 0.12rem;
  }

  .more {
    background: url("../../assets/images/up.png") center no-repeat !important;
    background-size: 0.18rem 0.12rem !important;
  }

  .check {
    width: 0.24rem;
    height: 0.24rem;
    border: 1px solid #979797;
    display: inline-block;
    border-radius: 50%;
    margin-bottom: 0.12rem;
    margin-right: .3rem;
  }

  .btn {
    background-color: rgba(0, 0, 0, 0);
    border: 0;
    color: #fff;
    font-size: .28rem;
    margin-top: .23rem;
  }

  .checked {
    background: url('../../assets/images/success_big.png') center no-repeat;
    background-size: 0.3rem 0.3rem;
    border: none;
  }

  .nochecked {
    border: 1px solid #979797;
  }

  .footList_wrap {
    width: 100%;
    position: fixed;
    bottom: 0rem;
    padding: 0 .4rem;
    /*height: 1rem;*/
    line-height: .5rem;
    background-color: #3f4b5f;
    color: #fff;
    font-size: .2rem;
    text-align: center;
  }

  .footList > li {
    width: 30%;
    float: left;
  }

  .footList1 > li {
    width: 30%;
    float: left;
    color: #cccccc;
  }

  .mint-tabbar {
    height: 1rem;
    font-size: 0.2rem !important;
    background-color: #3f4b5e;
  }

  .mint-tab-item {
    padding: .1rem .2rem !important;
  }

  .mint-tab-item-icon img {
    width: 0.34rem;
    height: 0.36rem;
    margin: 0 auto;
  }

  .mint-tab-item-icon {
    width: 100%;
    height: auto;
    margin: 0;
  }

  .back {
    width: .2rem;
    height: .3rem;
    /*margin-left: .3rem;*/
    background: url("../../assets/images/back.png") no-repeat;
    background-size: .2rem .3rem;
    display: inline-block;
    float: left;
    margin-top: .23rem;
  }

  .isClip {
    opacity: .6;
  }
</style>
<style scoped>
  .mint-tab-item-label {
    color: inherit;
  }

  .mint-msgbox-wrapper .mint-msgbox {
    height: 0 !important;
  }

  .selected {
    background-color: #3f4b5f;
    color: #fff !important;
    font-size: 0.2rem;
  }

  .selected-t a {
    opacity: 0.3;
  }

  .icon-success {
    background: url("../../assets/images/success_icon.png") center no-repeat;
    background-size: 0.98rem 0.7rem;
    margin: 0 auto;
    width: 0.98rem;
    height: 0.7rem;
  }

  .icon-error {
    background: url("../../assets/images/x.png") center no-repeat;
    margin: 0 auto;
    width: 0.98rem;
    height: 0.7rem;
  }

  html {
    overflow: scroll !important;
  }

  /*分享样式*/
  .mint-actionsheet {
    position: fixed;
    bottom: 0;
    width: 100%;
    background: #e0e0e0;
    /*text-align: center;*/
    transform: translate3d(-50%, 0, 0);
    backface-visibility: hidden;
    transition: transform .3s ease-out;
  }

  .mint-actionsheet-list {
    list-style: none;
    padding: 0;
    margin: 0;
  }

  .mint-actionsheet .shareTip {
    font-size: .3rem;
    text-align: left;
    padding-left: .3rem;
    color: #888 !important;
    height: .65rem;
    line-height: .65rem;
  }

  .mint-actionsheet-listitem {
    border-bottom: solid 1px #e0e0e0;
  }

  .mint-actionsheet-listitem span {
    width: 49%;
    height: 100%;
    display: inline-block;
  }

  .mint-actionsheet-listitem span:first-of-type {
    border-right: 1px solid #e0e0e0;
  }

  .mint-actionsheet-button {
    display: block;
    width: 100%;
    height: 45px;
    line-height: 45px;
    font-size: 18px;
    color: #333;
    background-color: #fff;
  }

  .mint-actionsheet-button:active {
    background-color: #f0f0f0;
  }

  .period {
    height: .81rem !important;
    line-height: .81rem;
  }

  .period li {
    width: 33.33%;
    height: 100%;
  }

  .period .aging {
    width: 0.24rem;
    height: 0.24rem;
    border: 1px solid #979797;
    display: inline-block;
    border-radius: 50%;
    margin-right: 5px;
  }

  .sharetime {
    height: 1.46rem !important;
    font-size: .3rem !important;
  }

  .v-model {
    position: fixed;
    left: 0;
    top: 0;
    width: 100%;
    height: 100%;
    opacity: .5;
    background: #000;
  }

  .actionsheet-float-enter,
  .actionsheet-float-leave-active {
    transform: translate3d(-50%, 100%, 0);
  }

  .liList {
    /*height: .99rem;*/
    display: flex;
    padding-top: 0.14rem;
    padding-left: .3rem;
  }
</style>
<style>
  .mint-msgbox-message .info {
    color: #9b9b9b;
    font-size: .28rem;
    margin-top: .2rem;
  }
</style>



// WEBPACK FOOTER //
// src/views/collect/collect.vue